module.exports = __webpack_public_path__ + "img/newsImg6-6.1f2b1230.png";